import cn from 'clsx';
import React, { forwardRef } from 'react';

import type { TextFieldModel } from '../../types';

import s from './BaseStyleTextField.module.scss';

const TextFieldBase = forwardRef<HTMLInputElement, TextFieldModel>(({ id, children, error, className, disabled, textSecurity, ...props }, ref) => {
  return (
    <label
      htmlFor={id}
      className={cn(s.wrapper, className, {
        [s.error as string]: error,
        [s.disabled as string]: disabled
      })}
    >
      <input ref={ref} id={id} disabled={disabled} className={cn(s.input, textSecurity && s.security)} {...props} />
      {children}
    </label>
  );
});

export default TextFieldBase;
